import { Map } from 'immutable';
export var keyBy = function keyBy(immutableList, keyAttr) {
  return immutableList.reduce(function (keyedMap, i) {
    return keyedMap.set(i.get(keyAttr), i);
  }, Map());
};

// Remove any undefined values
export var compact = function compact(immutableList) {
  return immutableList.filter(function (i) {
    return !!i;
  });
};

// Deep merge Maps, but not Lists or other Collections
var _mergeDeepOnlyMaps = function mergeDeepOnlyMaps(oldVal, newVal, key) {
  if (Map.isMap(oldVal) && Map.isMap(newVal)) {
    return oldVal.mergeWith(_mergeDeepOnlyMaps, newVal);
  }
  return newVal;
};
export { _mergeDeepOnlyMaps as mergeDeepOnlyMaps };